<template>
  <div>
    <div class="heading">Discount Codes</div>
    
    <div class="filter d-flex justify-space-between align-center">
      <div class="search-box">
        <label class="field-label">Search</label>
        <div class="search">
          <div class="search-input-box">
            <input type="text" v-model="searchKey" ref="search" :disabled="loading"
              @keypress.enter="search" @blur="search" />
            <transition name="slide-left">
              <i class="far fa-times-circle fa-lg" @click="clearSearch"
                v-if="searchKey.length > 0"></i>
            </transition>
          </div>
          <button :class="{'button xsmall success':true, 'disabled':loading}"
            @click="search">
            <i class="fas fa-search fa-lg"></i>
          </button>
        </div>
      </div>

      <div>
        <div class="button cta success" @click="showCreateModal">Add Discount Code</div>
      </div>
    </div>

    <list @search="search" />

    <!-- <div class="fix-footer">
      <div class="row">
        <div class="small-3 columns per-page">
          <span>Displaying</span>
          <select v-model="perPage" :disabled="loading">
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          <span>per page</span>
        </div>

        <div class="small-6 columns page-data">
          <span v-show="discountCodes.list.length > 0">
            Displaying
            <b>{{ pageData.start }}</b> - <b>{{ pageData.end }}</b> of
            <b>{{ pageData.max }}</b>
          </span>
        </div>

        <div class="small-3 columns pagination">
          <span>Page</span>
          <span :class="{'prevNext':true, 'disabled':currentPage === 1 || loading}" @click="prev">
            <i class="fas fa-chevron-left"></i>
          </span>
          <select v-model="currentPage" :disabled="loading">
            <option v-for="i in totalPage" :value="i" :key="i">{{i}}</option>
          </select>
          <span :class="{'prevNext':true, 'disabled':isLastPage || loading}" @click="next">
            <i class="fas fa-chevron-right"></i>
          </span>
        </div>
      </div>
    </div> -->

    <add-modal ref="addModal" @refresh="search" />
  </div>
</template>

<script>
import moment from 'moment-timezone'
import list from './List'
import addModal from './AddModal'

export default {
  name: 'settings',
  components: { list, addModal },
  data () {
    return {
      searchKey: '',
      addModal: {
        show: false
      }
    }
  },
  computed: {
    discountCodes () { return this.$store.state.discountCodes },
    loading: {
      get () { return this.discountCodes.loading },
      set (x) { this.$store.commit('discountCodes/setListData', {loading: x}) }
    },
    perPage: {
      get: function () { return this.discountCodes.perPage },
      set: function (value) {
        this.$store.commit('discountCodes/setListData', {
          perPage: value,
          currentPage: 1
        })
        this.search()
      }
    },
    pageData () {
      let tableData = this.discountCodes
      let start = (tableData.currentPage * tableData.perPage) - (tableData.perPage - 1)
      let end = tableData.currentPage * tableData.perPage
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      }
    },
    currentPage: {
      get: function () { return this.discountCodes.currentPage },
      set: function (value) {
        this.$store.commit('discountCodes/setListData', {currentPage: parseInt(value)} )
        this.search()
      }
    },
    isLastPage () {
      return (this.discountCodes.currentPage * this.discountCodes.perPage) >= this.discountCodes.maxList
    },
    totalPage () {
      return Math.ceil(this.discountCodes.maxList / this.discountCodes.perPage)
    }
  },
  methods: {
    showCreateModal () {
      if (this.$refs.addModal) {
        this.$refs.addModal.showModal()
      }
    },
    search () {
      let self = this
      if (self.loading) return

      self.loading = true
      self.$sdk.get('/discountcode', {
        token: self.$store.state.session.sessionToken,
        order: self.discountCodes.order,
        orderAsc: self.discountCodes.orderAsc,
        search: self.searchKey,
        pageSize: 999
      }, res => {
        self.loading = false
        if (res.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          })
          return
        }
        let list = []
        res.list.forEach(data => {
          list.push({
            id: data.id,
            code: data.code,
            amount: data.type === '%' ? `${data.amount}${data.type}` : `${data.type}${data.amount.toFixed(2)}`,
            created: moment(data.created, 'X').format('MM/DD/YYYY hh:mmA'),
            start: moment(data.start, 'X').format('MM/DD/YYYY hh:mmA'),
            end: moment(data.end, 'X').format('MM/DD/YYYY hh:mmA'),
            enabled: data.isWidget,
            appEnabled: data.isApp
          })
        })
        self.$store.commit('discountCodes/setListData', {list: list})
      })
    },
    clearSearch () {
      this.searchKey = ''
      this.search()
    },
    blurSearch () {

    },
    next () {

    },
    prev () {
      
    }
  },
  mounted () {
    this.search()
  }
}
</script>

<style lang="scss" scoped>
.heading{
  margin-left: 50px;
  padding-left: 10px;
  height: 50px;
  background: #fff;
  border-bottom: 1px solid #ddd;
  line-height: 50px;
  color: #3F2975;
  font-size: 21px;
  font-weight: 600;
  text-transform: uppercase;
}

.filter{
  border-bottom:1px solid #bbb;
  background: #fcfcfc;
  // margin-bottom: 10px;
  border-radius: 2px;
  padding: 10px 15px;
}
.search-box{
  position: relative;
  margin-bottom: 10px;
}
.field-label{
  font-size: 13px;
  color: #999;
  line-height: 1;
  display: block;
  margin-bottom: 4px;
}
.search{
  box-sizing: border-box;
  display: flex;
  width: 100%;

  .search-input-box{
    width: 100%;
    position: relative;

    input{
      display: inline-block;
      vertical-align: middle;
      margin-top: 0;
      border-radius: 5px 0 0 5px;
      padding-right: 30px;

      &.has-error{ border-color:#f33a27; }
    }
    i{
      position: absolute;
      top: 0;
      right: 5px;
      color: #d92626;
      cursor: pointer;
      line-height: 46px;
    }
  }
  button{
    display: inline-block;
    vertical-align: middle;
    line-height: 1;
    border-radius: 0 5px 5px 0;
    padding: 0 20px;
  }
}

.fix-footer{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background: #eaeaea;
  border-top: 1px solid #aaa;
  font-size: 13px;
  color: #555;

  .row{ max-width: 100%; }
  select{
    max-width: 100px;
    height: 30px;
    padding: 5px;
  }
  .per-page{
    display: flex;
    line-height: 30px;
    padding: 10px 0;

    span{
      display: inline-block;
      margin: 0 10px;
    }
  }
  .page-data{
    text-align: center;
    line-height: 30px;
    padding: 10px 0;
  }
  .pagination{
    text-align: right;
    padding: 10px 10px;

    span{
      display: inline-block;
      margin-right: 5px;
    }
    select{
      height: 30px;
      vertical-align: middle;
    }
    .prevNext{
      margin: 0 2px;
      padding: 0 8px;
      border: 1px solid #bbb;
      background: #fff;
      cursor: pointer;
      vertical-align: middle;
      height: 30px;

      i{ line-height:28px; }
      &.disabled{
        opacity: .4;
        cursor: default;
      }
    }
  }
}

@media screen and (max-width: 430px) {
  .filter {
    flex-wrap: wrap;
    justify-content: center !important;

    .search-box {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DiscountCodes/index.vue